import React, { useEffect, useState, useContext, useRef } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { GlobalTypes } from '../../../types/global';
import { GlobalContext } from '../../../context/GobalState';
import Button from '../Button/Button';
import TabPanel from '../TabPanel/TabPanel';
import { Checkbox, FormControlLabel, FormGroup, Box, Slide, Alert } from '@mui/material';

import { Rating } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import axios from 'axios';

import { QualityContent, RatingColumn, RatingWrapper } from './ModalQuality.styles';
import { api } from '../../../api/api';

// Dane odnośnie poszczególnego wiersza pobieramy gdy isActvie jest true, nie rzuca wtedy błędem
const ModalQuality = ({ data, isActive, setLastOpenItemId, tabValue, index }) => {
  const [isExpert, setIsExpert] = useState(false);
  const [showBorderTop, setShowBorderTop] = useState(false);
  const [showBorderBottom, setShowBorderBottom] = useState(false);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [value, setValue] = useState(false);
  const [responseForm, setResponseForm] = useState();
  const [technical_rating, setTechnicalRating] = useState([]);
  const [process_rating, setProcessRating] = useState([]);
  const [customer_behaviour_rating, setCustomerRating] = useState([]);
  const [out_of_scope_rating, setScopeRating] = useState([]);
  const [exist, setExist] = useState(false);
  const [alert, setAlert] = useState(false);
  const [sent, setSent] = useState(false);

  const [talkId, setTalkId] = useState('');

  const { authToken, permissionLevel, skill } = useContext(GlobalContext);
  const handleError = useErrorHandler();
  const scroll = useRef();
  useEffect(() => {
    data[0]?.talk_id && setTalkId(data[0].talk_id);
  }, [data]);
  useEffect(() => {
    if (authToken && permissionLevel === GlobalTypes.PERMISSION_LEVEL_E && skill) {
      axios
        .get(`${api}data/talk_rating/get_empty_rating_form/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then((response) => {
          setResponseForm(response.data);
        });
    }
    // eslint-disable-next-line
  }, [talkId]);
  useEffect(() => {
    talkId &&
      axios
        .get(`${api}data/talk_rating/${talkId}/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setTechnicalRating(response.data.technical_rating);
            setProcessRating(response.data.process_rating);
            setCustomerRating(response.data.customer_behaviour_rating);
            setScopeRating(response.data.out_of_scope_rating);
            setExist(true);
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            setTechnicalRating([]);
            setProcessRating([]);
            setCustomerRating([]);
            setScopeRating([]);
            setExist(false);
          }
        });
  }, [talkId, authToken]);

  useEffect(() => {
    setLastOpenItemId(talkId);
  }, [setLastOpenItemId, talkId]);

  useEffect(() => {
    if (permissionLevel === GlobalTypes.PERMISSION_LEVEL) {
      setIsExpert(true);
    }
  }, [permissionLevel]);

  const onScroll = (e) => {
    const currentScrollY = e.target.scrollTop;
    if (currentScrollY > 0) {
      setShowBorderTop(true);
    } else {
      setShowBorderTop(false);
    }

    if (e.target.offsetHeight + currentScrollY >= e.target.scrollHeight) {
      setIsScrolledToBottom(true);
    } else {
      setIsScrolledToBottom(false);
    }
  };

  const handleTechRating = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setTechnicalRating((prevState) => [...prevState, value]);
    } else {
      setTechnicalRating((prevState) => prevState.filter((rating) => rating !== value));
    }
  };
  const handleProRating = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setProcessRating((prevState) => [...prevState, value]);
    } else {
      setProcessRating((prevState) => prevState.filter((rating) => rating !== value));
    }
  };
  const handleCustRating = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setCustomerRating((prevState) => [...prevState, value]);
    } else {
      setCustomerRating((prevState) => prevState.filter((rating) => rating !== value));
    }
  };
  const handleScopeRating = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setScopeRating((prevState) => [...prevState, value]);
    } else {
      setScopeRating((prevState) => prevState.filter((rating) => rating !== value));
    }
  };
  const onSubmit = (data) => {
    if (exist === false) {
      axios
        .post(
          `${api}data/talk_rating/`,
          {
            talk_id: talkId,
            process_rating: process_rating,
            technical_rating: technical_rating,
            customer_behaviour_rating: customer_behaviour_rating,
            out_of_scope_rating: out_of_scope_rating,
          },
          {
            headers: {
              Authorization: `token ${authToken}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 201) {
            setExist(true);
            setSent(true);
            setAlert(true);
            setTimeout(() => {
              setAlert(false);
            }, 2000);
          }
        });
    }
    if (exist === true) {
      axios
        .patch(
          `${api}data/talk_rating/${talkId}/`,
          {
            process_rating: process_rating,
            technical_rating: technical_rating,
            customer_behaviour_rating: customer_behaviour_rating,
            out_of_scope_rating: out_of_scope_rating,
          },
          {
            headers: {
              Authorization: `token ${authToken}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            setSent(true);
            setAlert(true);
            setTimeout(() => {
              setAlert(false);
            }, 2000);
          }
        });
    }
  };

  return (
    <TabPanel value={tabValue} index={index}>
      {alert ? (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translate(-50%, calc(-50% + 35px) )',
            zIndex: 1600,
          }}
        >
          <Slide direction="down" in={!!alert} mountOnEnter unmountOnExit>
            <Alert severity="success" sx={{ width: '600px' }}>
              <p>Rating saved!</p>
            </Alert>
          </Slide>
        </Box>
      ) : (
        ''
      )}
      <QualityContent onScroll={onScroll} ref={scroll}>
        <RatingColumn>
          <RatingWrapper>
            <h4>Technical rating</h4>
            {responseForm?.technical_rating.map((rating, index) => (
              <FormControlLabel
                key={index}
                control={<Checkbox checked={technical_rating.includes(rating)} />}
                label={rating}
                labelPlacement={'end'}
                value={rating}
                sx={{ mb: 2 }}
                onChange={handleTechRating}
                // disabled={ isProduction}
              />
            ))}
          </RatingWrapper>
        </RatingColumn>
        <RatingColumn>
          <RatingWrapper>
            <h4>Process rating</h4>
            {responseForm?.process_rating.map((rating, index) => (
              <FormControlLabel
                key={index}
                control={<Checkbox checked={process_rating.includes(rating)} />}
                label={rating}
                labelPlacement={'end'}
                value={rating}
                sx={{ mb: 2 }}
                onChange={handleProRating}
                // disabled={ isProduction}
              />
            ))}
          </RatingWrapper>
        </RatingColumn>
        <RatingColumn>
          <RatingWrapper>
            <h4>Customer behaviour rating</h4>
            {responseForm?.customer_behaviour_rating.map((rating, index) => (
              <FormControlLabel
                key={index}
                control={<Checkbox checked={customer_behaviour_rating.includes(rating)} />}
                label={rating}
                labelPlacement={'end'}
                value={rating}
                sx={{ mb: 2 }}
                onChange={handleCustRating}
                // disabled={ isProduction}
              />
            ))}
          </RatingWrapper>
        </RatingColumn>
        <RatingColumn>
          <RatingWrapper>
            <h4>Out of scope rating</h4>
            {responseForm?.out_of_scope_rating.map((rating, index) => (
              <FormControlLabel
                key={index}
                control={<Checkbox checked={out_of_scope_rating.includes(rating)} />}
                label={rating}
                labelPlacement={'end'}
                value={rating}
                sx={{ mb: 2 }}
                onChange={handleScopeRating}
                // disabled={ isProduction}
              />
            ))}
          </RatingWrapper>
        </RatingColumn>
      </QualityContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        <Button contained white onClick={onSubmit}>
          Save
        </Button>
      </Box>
    </TabPanel>
  );
};

export default ModalQuality;
